import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["micronInput", "gradeInput"]

  connect() {
    this.setupShornListener()
    this.initializeGrade()
  }

  // When shorn is set to NO, also set crutch to NO
  // UI requirement: animals can only be crutched if they've been shorn
  setupShornListener() {
    const shornInput = this.element.querySelector('input[name="assessment[shearing_form][shorn]"], input[name="shearing[shorn]"]')
    const crutchedInput = this.element.querySelector('input[name="assessment[shearing_form][crutched_since_last_shearing]"], input[name="shearing[crutched_since_last_shearing]"]')
    
    if (shornInput && crutchedInput) {
      shornInput.addEventListener("change", () => {
        // Handle both string ("1"/"0") and boolean values depending on context
        const isShorn = shornInput.value === "1" || shornInput.value === "true" || shornInput.checked
        if (!isShorn) {
          // Reset crutched toggle to NO and trigger change event
          // Event triggers both binary-toggle (button styles) and toggle-display (show/hide field)
          crutchedInput.value = "0"
          crutchedInput.checked = false
          crutchedInput.dispatchEvent(new Event("change", { bubbles: true }))
        }
      })
    }
  }

  // Called when user changes micron range dropdown
  onMicronChange() {
    this.initializeGrade()
  }

  // Auto-populate wool grade based on selected micron range
  // Grades mapping comes from Shearing::MICRON_TO_GRADE constant
  // This ensures grade always matches micron (enforced by validation)
  initializeGrade() {
    if (!this.hasMicronInputTarget || !this.hasGradeInputTarget) return
    const grades = JSON.parse(this.micronInputTarget.dataset.grades || "{}")
    this.gradeInputTarget.value = grades[this.micronInputTarget.value] || ""
  }
}
